import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { TagIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../route';

// The legacy Discounts page, moved here from /discounts when Discounts v2
// took over the unversioned path. Its components intentionally stay in
// ../discounts/ (folder not renamed to avoid churn). Served to tenants whose
// org does not have `orderManagement.enhancedSalesOrderUi` enabled;
// visibility is governed purely by RBAC (Read/Discount).
const DiscountsPage = lazyRouteComponent(
  () => import('../discounts/DiscountsPage'),
  'DiscountsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/discounts-v1',
  staticData: {
    app: {
      nav: {
        label: 'Discounts',
        icon: <TagIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Discount }],
      },
    },
  },
  component: DiscountsPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    sku?: string;
    customerId?: string;
    customerName?: string;
    tab?: string;
  } => ({
    sku: typeof search.sku === 'string' ? search.sku : undefined,
    customerId:
      typeof search.customerId === 'string' ? search.customerId : undefined,
    customerName:
      typeof search.customerName === 'string' ? search.customerName : undefined,
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  loader: () => ({
    crumb: 'Discounts',
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Discount,
    });
  },
});
